import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class ClientStatementExpenseModel extends Model {
  @attr('string') description!: string;
  @attr('number') quantity!: number;
  @attr('number') unitPrice!: number;
  @attr('number') amountWithTax!: number;
  @attr('number') amountWithoutTax!: number;
  @attr('number') unitPriceWithoutTax!: number;
  @attr('boolean') recurring!: boolean;

  @belongsTo('client-statement', {
    inverse: 'expenses',
    async: false,
  })
  clientStatement!: ModelRegistry['client-statement'];

  @belongsTo('tax', { inverse: null, async: false })
  tax?: ModelRegistry['tax'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'client-statement-expense': ClientStatementExpenseModel;
  }
}
